import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardRoutingModule } from './card-routing.module';
import { CardComponent } from './card.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {CardModule} from "../../component/ing/card/card";
import {ButtonModule} from "../../component/ing/button/button";
import {Header,Footer} from "../../component/ing/common/shared";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CardRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    CardModule,
    TableModule,
    ButtonModule
  ],
  declarations: [CardComponent]
})
export class CardDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/card/cardDemo.module.ts